import { useEffect } from "react";

export interface UseDocumentTitleOptions {
  title: string;
  prevailOnUnmount?: boolean;
}

export const useDocumentTitle = ({
  title,
  prevailOnUnmount = false,
}: UseDocumentTitleOptions) => {
  const titleSuffix = "Seemplicity";

  useEffect(() => {
    document.title = title + " - " + titleSuffix;
  }, [title]);

  useEffect(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = titleSuffix;
      }
    },
    []
  );
};
